<template>
  <v-layout>
    <v-container grid-list-md>
  
          <!--sale area starts-->

          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-btn class="mx-3" @click="show_sale_form = !show_sale_form" :color="show_sale_form?'primary':''">
                <v-icon v-if="show_sale_form">add</v-icon>
                <v-icon v-else>remove</v-icon>New Transaction
              </v-btn>
              <!-- <v-btn @click.stop="dialog=true">
              show receipt
            </v-btn>-->
              <!--transactions form starts-->
              <v-card
                style="width: 98%; display: block; margin: 0 auto"
                class="elevation-1 mt-5"
                v-if="!show_sale_form"
              >
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-btn
                        @click="
                          show_sale_item_input = !show_sale_item_input;
                          sale_items = [];
                          resetTransModel();
                        "
                      >
                        <v-icon>add</v-icon>Add Item
                      </v-btn>
                    </v-flex>
                    <v-flex xs7>
                      <v-text-field
                        solo
                        placeholder="Item Code"
                        style="width: 20%"
                        ref="itemCode"
                        v-model="itSearchCode"
                        @input="getItemByCode()"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex xs3>
                      <h4 style="text-align: right">
                        Sub-Total: GH&#8373;
                        {{ trans_model.cum_amt | currency }}
                      </h4>
                      <h4 style="text-align: right">
                        VAT: {{ trans_model.vat_perc }} %
                      </h4>
                      <h4 style="text-align: right">
                        Discount: {{ trans_model.discount_perc }} %
                      </h4>
                      <h4 style="text-align: right; font-weight: bold">
                        Grand Total: GH&#8373;
                        {{ trans_model.payable_amount | currency }}
                      </h4>
                    </v-flex>
                  </v-layout>

                  <!--sale item selection row starts-->
                  <v-form ref="itmSelStrip">
                    <v-layout
                      row
                      wrap
                      style="margin-bottom: 10px"
                      v-if="!show_sale_item_input"
                    >
                      <v-flex xs5>
                        <v-autocomplete
                          :items="selectOptions"
                          label="Item"
                          required
                          v-model="selected_sale_item"
                          item-text="label"
                          clearable
                          @change="clearSelected()"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          readonly
                          label="Available Quantity"
                          v-model="selected_sale_item.quantity"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          readonly
                          label="Unit Price"
                          v-model="selected_sale_item.unit_price"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                        <v-text-field
                          label="Quantity"
                          ref="purchQuan"
                          v-model="sitm_quan"
                          @keyup.enter="
                            addProdToList();
                            useBCScanner();
                          "
                          type="number"
                          step="any"
                          :rules="[
                            (v) =>
                              v <= selected_sale_item.quantity ||
                              'must not be greater than available quantity',
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                          readonly
                          label="Total Price"
                          v-model="selected_sale_item.total"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                  <!--sale item selection row ends-->

                  <!--sale item list starts -->
                  <v-card v-if="sale_items.length">
                    <v-card-title style="background: #eee">
                      <h4 style="text-align: center">Purchase List</h4>
                    </v-card-title>
                    <v-card-text>
                      <v-layout
                        row
                        v-for="(sale_item, key) in sale_items"
                        :key="key"
                        style="
                          border-top: 1px solid lightgray;
                          padding-top: 5px;
                        "
                        class="mb-5"
                      >
                        <v-flex xs3>(Item): {{ sale_item.name }}</v-flex>
                        <v-flex xs3
                          >(Unit Price): GH&#8373;
                          {{ sale_item.unit_price | currency }}</v-flex
                        >
                        <v-flex xs2
                          >(Quantity): {{ sale_item.squantity }}</v-flex
                        >
                        <v-flex xs3
                          >(Total): GH&#8373;
                          {{ sale_item.total | currency }}</v-flex
                        >
                        <v-flex xs1>
                          <v-btn
                            text
                            icon
                            color="pink"
                            @click.native="deleteFromPurchList(sale_items, key)"
                          >
                            <v-icon>clear</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <!--sale item list ends-->

                  <v-divider style="margin-bottom: 10px"></v-divider>
                  <v-form ref="form" lazy-validation>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-text-field
                          height="1"
                          label="VAT(%)"
                          outlined
                          v-model="trans_model.vat_perc"
                          :rules="valid_rules.vatRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          height="1"
                          label="Discount(%)"
                          outlined
                          v-model="trans_model.discount_perc"
                          :rules="valid_rules.discRules"
                          :disabled="
                            current_user.user_details &&
                            current_user.user_details.role === 'administrator'
                              ? false
                              : true
                          "
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-select
                          :disabled="
                            current_user.user_details &&
                            current_user.user_details.role !== 'administrator'
                          "
                          height="1"
                          :items="['Cash', 'Credit']"
                          outlined
                          label="Mode of Payment"
                          v-model="trans_model.mop"
                          :rules="valid_rules.mopRules"
                        ></v-select>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-text-field
                          height="1"
                          label="Payable Amount(GHS)"
                          outlined
                          readonly
                          v-model="trans_model.payable_amount"
                          :rules="valid_rules.pamtRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          ref="amtd"
                          height="1"
                          label="Amount Tendered"
                          outlined
                          v-model="trans_model.amt_tendered"
                          :rules="amtTConfirmationRule"
                          @click="clearAmtTendered()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          height="1"
                          label="Change Due"
                          outlined
                          readonly
                          v-model="trans_model.change_due"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs4>
                        <!-- <v-text-field
                        label="Customer Name"
                        outlined
                        v-model="trans_model.cust_name"
                        :rules="custNameRule"
                      ></v-text-field>-->

                        <v-combobox
                          height="1"
                          outlined
                          :return-object="false"
                          v-model="dummyCnameModel"
                          :rules="custNameRule"
                          :items="customers"
                          @change="onCNAutoCompleteSelection"
                          @keyup="customCnOnChangeHandler"
                          @paste="customCnOnChangeHandler"
                          item-text="cust_name"
                          item-value="cust_name"
                          label="Customer Name"
                          ref="cncb"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs4>
                        <!-- <v-text-field
                        label="Customer Phone"
                        outlined
                        v-model="trans_model.cust_phone"
                        :rules="custPhoneRule"
                      ></v-text-field>-->

                        <v-combobox
                          outlined
                          height="1"
                          v-model="dummyPhoneModel"
                          :rules="custPhoneRule"
                          :items="customers"
                          item-text="cust_phone"
                          item-value="cust_phone"
                          label="Customer Phone"
                          :return-object="false"
                          ref="cpcb"
                          @change="onCPAutoCompleteSelection"
                          @keyup="customCpOnChangeHandler"
                          @paste="customCpOnChangeHandler"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs4>
                        <v-combobox
                          outlined
                          height="1"
                          v-model="dummyAddressModel"
                          :items="customers"
                          item-text="cust_address"
                          item-value="cust_address"
                          label="Address/Location"
                          :return-object="false"
                          ref="cacb"
                          @change="onCAAutoCompleteSelection"
                          @keyup="customCaOnChangeHandler"
                          @paste="customCaOnChangeHandler"
                        ></v-combobox>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs9></v-flex>
                      <v-flex xs3>
                        <h4 style="text-align: right">
                          Sub-Total: GH&#8373;
                          {{ trans_model.cum_amt | currency }}
                        </h4>
                        <h4 style="text-align: right">
                          VAT: {{ trans_model.vat_perc }} %
                        </h4>
                        <h4 style="text-align: right">
                          Discount: {{ trans_model.discount_perc }} %
                        </h4>
                        <h4 style="text-align: right; font-weight: bold">
                          Grand Total: GH&#8373;
                          {{ trans_model.payable_amount | currency }}
                        </h4>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-btn @click="useBCScanner()">Use Barcode Scanner</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn @click="clear()">Clear</v-btn>
                      <v-btn @click="makeSale()" class="ml-3">Confirm Order</v-btn>

                      <!-- <v-flex xs3></v-flex>
                    <v-flex xs5>
                      
                      
                      <v-btn color="error">Close</v-btn>
                    </v-flex>-->
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>

              <!--transactions form ends-->
              <!--transactions table starts-->
              <v-card class="mt-5">
                <v-card-title>
                  <h4 style="text-align: center">Transactions</h4>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="trans_headers"
                    :items="transactions"
                    :search="search"
                    class="elevation-1"
                    :loading="salesloading"
                  >
                    <!-- <template v-slot:items="props">
                    <td
                      @click="view_trans(props.item)"
                      style="cursor: pointer; color: blue"
                    >
                      {{ pad(props.item.id, 8) }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.items.length }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.payable_amount | currency }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.amt_tendered | currency }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.change_due | currency }}
                    </td>
                    <td class="text-xs-center">{{ props.item.mop }}</td>
                    <td class="text-xs-center">{{ props.item.staff }}</td>
                    <td class="text-xs-center">
                      {{
                        props.item.cust_name
                          ? props.item.cust_name +
                            "(" +
                            props.item.cust_phone +
                            ")"
                          : "N/A"
                      }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        moment(new Date(props.item.created_at)).format(
                          "DD-MM-YYYY @ h:mm:ss A"
                        )
                      }}
                    </td>
                    <td>
                      <v-btn
                        icon
                        text
                        color="pink"
                        v-if="
                          current_user.user_details &&
                          current_user.user_details.role === 'administrator'
                        "
                        @click="deleteSale(props.item, props.index)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>

                      <v-btn text icon disabled v-else>
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </template> -->

                    <template v-slot:item.id="{ item }">
                      <td
                        @click="view_trans(item)"
                        style="cursor: pointer; color: blue"
                      >
                        {{ pad(item.id, 8) }}
                      </td>
                    </template>

                    <template v-slot:item.tot_items="{ item }">
                      {{ Number(item.items.length).toLocaleString() }}
                    </template>

                    <template v-slot:item.payable_amount="{ item }">
                      {{ parseFloat(item.payable_amount) | currency }}
                    </template>
                    <template v-slot:item.amt_tendered="{ item }">
                      {{ parseFloat(item.amt_tendered) | currency }}
                    </template>
                    <template v-slot:item.change_due="{ item }">
                      {{ parseFloat(item.change_due) | currency }}
                    </template>

                    <template v-slot:item.cust_name="{ item }">
                      {{
                        item.cust_name
                          ? item.cust_name + "(" + item.cust_phone + ")"
                          : "N/A"
                      }}
                    </template>

                    <template v-slot:item.date="{ item }">
                      {{
                        moment(new Date(item.created_at)).format(
                          "DD-MM-YYYY @ h:mm A"
                        )
                      }}
                    </template>
                    <template v-slot:item.actions="{ item, index }">
                      <v-btn
                        icon
                        text
                        color="pink"
                        v-if="
                          current_user.user_details &&
                          current_user.user_details.role === 'administrator'
                        "
                        @click="deleteSale(item, index)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>

                      <v-btn text icon disabled v-else>
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <!--transactions table ends-->
            </v-flex>
          </v-layout>

          <!--sale area ends-->

          <!-- transaction receipt begins -->
          <v-dialog v-model="dialog" max-width="400">
            <receipt :dialog_id="'rcpt1'">
              <template v-slot:shop-info>
                <shopinf></shopinf>
                <p>{{ transrcpt_model.created_at }}</p>
                <p>#{{ pad(transrcpt_model.id, 8) }}</p>
              </template>
              <template v-slot:item-list>
                <v-data-table
                  :headers="ritems_headers"
                  :items="transrcpt_model.items"
                  hide-default-footer
                  class="elevation-0 rcpttbl"
                >
                  <!-- <template v-slot:items="props">
                  <td>{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.squantity }}</td>
                  <td class="text-xs-center">
                    {{ props.item.unit_price | currency }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.total | currency }}
                  </td>
                </template> -->

                  <template v-slot:item.unit_price="{ item }">
                    {{ parseFloat(item.unit_price) | currency }}
                  </template>

                  <template v-slot:item.total="{ item }">
                    {{ parseFloat(item.total) | currency }}
                  </template>
                </v-data-table>
              </template>

              <template v-slot:cost-summary>
                <p style="text-align: right">
                  Sub-Total: GH&#8373; {{ transrcpt_model.cum_amt | currency }}
                </p>
                <p style="text-align: right">
                  VAT: {{ transrcpt_model.vat_perc }} %
                </p>
                <p style="text-align: right">
                  Discount: {{ transrcpt_model.discount_perc }} %
                </p>
                <p style="text-align: right; font-weight: bold">
                  Grand Total: GH&#8373;
                  {{ transrcpt_model.payable_amount | currency }}
                </p>
              </template>
              <template v-slot:payment-info>
                <p>Mode of Payment: {{ transrcpt_model.mop }}</p>
                <p>
                  Amount Tendered: GH&#8373;
                  {{ transrcpt_model.amt_tendered | currency }}
                </p>
                <p>
                  Change: GH&#8373; {{ transrcpt_model.change_due | currency }}
                </p>
              </template>

              <template v-slot:customer-info>
                <p>Customer Name: {{ transrcpt_model.cust_name }}</p>
                <p>Customer Phone: {{ transrcpt_model.cust_phone }}</p>
                <p>Customer Address: {{ transrcpt_model.cust_address }}</p>
              </template>

              <template v-slot:tu-note>
                <p>Thank you for your partronage</p>

                <p
                  style="
                    font-style: italic;
                    font-size: 10px;
                    text-align: center;
                  "
                >
                  Developed by GoPear Technologies (0506340523)
                </p>
              </template>
            </receipt>
          </v-dialog>
          <!-- transaction receipt ends -->

          <!-- for viewing past transactions -->
          <v-dialog v-model="v_trans_dialog" max-width="430">
            <receipt :dialog_id="'rcpt2'">
              <template v-slot:shop-info>
                <shopinf></shopinf>
                <p>{{ v_trans_model.created_at }}</p>
                <p>#{{ pad(v_trans_model.id, 8) }}</p>
              </template>
              <template v-slot:item-list>
                <v-data-table
                  :headers="ritems_headers"
                  :items="v_trans_model.items"
                  hide-default-footer
                  class="elevation-0 rcpttbl"
                >
                  <!-- <template v-slot:items="props">
                  <td>{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.squantity }}</td>
                  <td class="text-xs-center">
                    {{ props.item.unit_price | currency }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.total | currency }}
                  </td>
                </template> -->

                  <template v-slot:item.unit_price="{ item }">
                    {{ parseFloat(item.unit_price) | currency }}
                  </template>

                  <template v-slot:item.total="{ item }">
                    {{ parseFloat(item.total) | currency }}
                  </template>
                </v-data-table>
              </template>

              <template v-slot:cost-summary>
                <p style="text-align: right">
                  Sub-Total: GH&#8373; {{ v_trans_model.cum_amt | currency }}
                </p>
                <p style="text-align: right">
                  VAT: {{ v_trans_model.vat_perc }} %
                </p>
                <p style="text-align: right">
                  Discount: {{ v_trans_model.discount_perc }} %
                </p>
                <p style="text-align: right; font-weight: bold">
                  Grand Total: GH&#8373;
                  {{ v_trans_model.payable_amount | currency }}
                </p>
              </template>

              <template v-slot:payment-info>
                <p>Mode of Payment: {{ v_trans_model.mop }}</p>
                <p>
                  Amount Tendered: GH&#8373;
                  {{ v_trans_model.amt_tendered | currency }}
                </p>
                <p>
                  Change: GH&#8373; {{ v_trans_model.change_due | currency }}
                </p>
              </template>

              <template v-slot:customer-info>
                <p>Customer Name: {{ v_trans_model.cust_name }}</p>
                <p>Customer Phone: {{ v_trans_model.cust_phone }}</p>
                <p>Customer Address: {{ v_trans_model.cust_address }}</p>
              </template>

              <template v-slot:tu-note>
                <p>Thank you for your partronage</p>
                <p
                  style="
                    font-style: italic;
                    font-size: 12px;
                    text-align: center;
                  "
                >
                  Developed by GoPear Technologies (0506340523)
                </p>
              </template>
            </receipt>
          </v-dialog>
       
    </v-container>
    <snackbar ref="sb"></snackbar>
  </v-layout>
</template>

<style>
p {
  margin-bottom: 0px;
}

.rcpttbl table {
  table-layout: fixed;
}
</style>

<script>
import receipt from "../shared/trans_receipt";
import shopinf from "../shared/shopDetails";
import snackbar from "../shared/snackbar";
import ItemService from "../../services/item-service";
import TransactionService from "../../services/sale-service";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    receipt,
    shopinf,
    snackbar,
  },
  data() {
    return {
      site_online: false,
      dummyCnameModel: "",
      dummyPhoneModel: "",
      dummyAddressModel: "",
      sitm_quan: "",
      valid: true,
      lazy: false,
      valid_rules: {
        mopRules: [
          (v) => !!v || "Mode of Payment is required",
          // v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        pamtRules: [
          (v) => !!v || "Payable Amount is required",
          (v) => v >= 0 || "Payable Amount must be greater than 0",
        ],
        vatRules: [
          //v => !!v || "VAT is required",
          (v) => v >= 0 || "VAT cannot be less than 0",
        ],
        phoneRules: [
          //v =>  v.length > 10 || "Phone number must not be less than 10 digits"
          //v => v.length > 12 || 'Phone number must not be more than 12 digits',
        ],
      },
      moment: moment,
      search: "",
      show_sale_form: true,
      show_sale_item_input: true,
      itSearchCode: "",
      dialog: false,
      v_trans_dialog: false,
      selected_sale_item: {
        quantity: "",
        squantity: "",
        unit_price: "",
      },

      sale_items: [],
      v_trans_model: {
        items: [],
        vat_perc: 0.0,
        discount_perc: 0.0,
        mop: "Cash", //mode of payment
        staff: "",
        cum_amt: 0.0, //cumulative amount
        payable_amount: 0.0,
        amt_tendered: 0.0,
        change_due: 0.0,
        cust_name: "",
        cust_phone: "",
        cust_address: "",
      },
      trans_model: {
        items: [],
        vat_perc: 0.0,
        discount_perc: 0.0,
        mop: "Cash", //mode of payment
        staff: "",
        cum_amt: 0.0, //cumulative amount
        payable_amount: 0.0,
        amt_tendered: 0.0,
        change_due: 0.0,
        cust_name: "",
        cust_phone: "",
        cust_address: "",
        customer: "",
      },
      transrcpt_model: {},
      trans_headers: [
        {
          text: "Receipt No.",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Total Items",
          align: "center",
          sortable: false,
          value: "tot_items",
        },
        {
          text: "Total Amount",
          align: "center",
          sortable: false,
          value: "payable_amount",
        },
        {
          text: "Amount Tendered",
          align: "center",
          sortable: false,
          value: "amt_tendered",
        },
        {
          text: "Change Due",
          align: "center",
          sortable: false,
          value: "change_due",
        },
        {
          text: "Mode of Payment",
          align: "center",
          sortable: false,
          value: "mop",
        },
        {
          text: "Staff",
          align: "center",
          sortable: false,
          value: "staff",
        },
        {
          text: "Customer",
          align: "center",
          sortable: false,
          value: "cust_name",
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "date",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],

      ritems_headers: [
        {
          text: "ITEM",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "QTY.",
          align: "center",
          sortable: false,
          value: "squantity",
        },
        {
          text: "PRICE",
          align: "center",
          sortable: false,
          value: "unit_price",
        },
        {
          text: "AMOUNT",
          align: "center",
          sortable: false,
          value: "total",
        },
      ],
    };
  },
  created() {
    //this.$store.dispatch("Layouts/set_layout", "sale-layout");
    this.$store.dispatch("Items/getAll");
    this.$store.dispatch("Sales/getAll");
    this.$store.dispatch("Customers/getAll");
    this.$store.dispatch("settings/getAll");

    if (this.site_online) {
      this.$store.dispatch("sms/getBalance", "");
    }
  },
  methods: {
    clearAmtTendered() {
      if (parseFloat(this.trans_model.amt_tendered) == 0) {
        this.trans_model.amt_tendered = "";
      }
    },
    onCNAutoCompleteSelection() {
      this.trans_model.cust_name = this.dummyCnameModel;
    },
    onCPAutoCompleteSelection() {
      this.trans_model.cust_phone = this.dummyPhoneModel;
    },

    onCAAutoCompleteSelection() {
      this.trans_model.cust_address = this.dummyAddressModel;
    },

    customCnOnChangeHandler() {
      //custom onchange handler for customer name (cn)
      let vm = this;
      setTimeout(() => {
        if (vm.$refs.cncb) {
          vm.trans_model.cust_name = vm.$refs.cncb.internalSearch;
        }
      });
    },

    customCpOnChangeHandler() {
      //custom onchange handler for customer phone (cp)
      let vm = this;
      setTimeout(() => {
        if (vm.$refs.cpcb) {
          vm.trans_model.cust_phone = vm.$refs.cpcb.internalSearch;
        }
      });
    },

    customCaOnChangeHandler() {
      //custom onchange handler for customer phone (cp)
      let vm = this;
      setTimeout(() => {
        if (vm.$refs.cacb) {
          vm.trans_model.cust_address = vm.$refs.cacb.internalSearch;
        }
      });
    },

    loggg(c) {
      console.log(c);
    },
    useBCScanner() {
      this.$refs.itemCode.focus();
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },
    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    clearSelected() {
      if (!this.selected_sale_item) {
        this.resetSelSaleItem();
        //console.log("nothingoo");
      }
    },
    addProdToList() {
      //add to customer selected sale_item list

      // console.log("buuuuuu",this.selected_sale_item)

      if (!this.$refs.itmSelStrip.validate()) {
        return false;
      }
      if (this.selected_sale_item.code && this.selected_sale_item.squantity) {
        let tobedeleted = this.stock_items.indexOf(this.selected_sale_item);
        this.sale_items.unshift(this.selected_sale_item);
        this.sumPurchaseList(this.sale_items, "total");
        this.$store.dispatch("Items/removeSaleItemFromStock", tobedeleted);
        this.resetSelSaleItem();
        this.itSearchCode = "";
        this.trans_model.items = this.sale_items;
        this.sitm_quan = "";
        // console.log(this.selected_sale_item)
      }
    },
    resetSelSaleItem() {
      this.selected_sale_item = {
        quantity: "",
        squantity: "",
        unit_price: "",
      };
    },
    getItemByCode() {
      var found_item = this.stock_items.find((obj) => {
        //.filter returns and array .find returns an object, here we need an object so we use .find
        return obj.code === this.itSearchCode;
      });
      if (found_item) {
        this.show_sale_item_input = false;
        this.selected_sale_item = found_item;
        if (this.$refs.purchQuan) {
          this.$refs.purchQuan.focus();
        }

        // console.log(found_item)
      } else {
        this.resetSelSaleItem();
      }
    },
    sumPurchaseList(items, prop) {
      var sum = items.reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b[prop]);
      }, 0);

      this.trans_model.cum_amt = sum;
    },
    deleteFromPurchList(items, key) {
      let c = items[key];
      c.squantity = null;
      c.total = null;
      this.$store.dispatch("Items/readdSaleItemToStock", c); //re add deleted item in purchase list back to stock items
      this.$delete(items, key);
      this.sumPurchaseList(items, "total");
    },

    makeSale() {
      // console.log(this.trans_model.cust_name)

      // return

      if (
        this.trans_model &&
        parseFloat(this.trans_model.amt_tendered) <
          this.trans_model.payable_amount &&
        this.trans_model.mop == "Cash"
      ) {
        this.$toast.error("PLEASE ENTER PAYMENT");
        this.$refs.amtd.focus();
        this.trans_model.amt_tendered = "";
        return;
      }
      if (this.$refs.form.validate()) {
        this.transrcpt_model = {};

        this.trans_model.staff = this.current_user.user_details.name;
        this.$store.dispatch("Sales/add", this.trans_model);
        if (this.terrors == null) {
          //this.$store.dispatch("Items/getAll");

          if (
            this.trans_model.cust_phone &&
            this.settings.sms.send_tyn &&
            this.sms_balance &&
            this.sms_balance > 0
          ) {
            this.$store.dispatch("sms/send", {
              key: "", //now picking from backend
              to: this.trans_model.cust_phone,
              msg: this.settings.sms.tyn_msg,
              senderid: "", //now picking from backend
            });
          }
          this.resetTransModel();
          this.resetCombobxs();
          this.sale_items = [];

          setTimeout(() => {
            this.$store.dispatch("Items/getAll");
          }, 2000);
        }
      }
    },
    deleteSale(sale, index) {
      if (confirm("Are you sure you want to delete this transaction?")) {
        this.$store.dispatch("Sales/delete", { sale, index });

        var sb = this.$refs.sb;

        if (this.terrors == null) {
          //this.$store.dispatch("Items/getAll");
          this.snackbarconf(sb, "transaction deleted successfully.", "success");

          setTimeout(() => {
            this.$store.dispatch("Items/getAll");
          }, 2000);
        } else {
          this.snackbarconf(
            sb,
            "Sorry, an error occured and transaction could not be deleted.",
            "error"
          );
        }
      }
    },
    view_trans(val) {
      this.v_trans_model = val;
      this.v_trans_dialog = true;
    },
    replaceEmptyWithZ(val) {
      if (val == "") {
        val = 0;
      }
    },
    resetTransModel() {
      this.trans_model = {
        items: [],
        vat_perc: 0.0,
        discount_perc: 0.0,
        mop: "Cash", //mode of payment
        staff: "",
        cum_amt: 0.0, //cumulative amount
        payable_amount: 0.0,
        amt_tendered: 0.0,
        change_due: 0.0,
        cust_name: "",
        cust_phone: "",
        cust_address: "",
        customer: "",
      };
    },
    clear() {
      // if (this.trans_model.cum_amt) {
      if (confirm("Are you sure you want to clear this form?")) {
        this.$store.dispatch("Items/getAll");
        //this.$refs.form.reset();
        this.sale_items = [];
        this.resetTransModel();
        this.selected_sale_item = {};
        this.sitm_quan = "";

        this.resetCombobxs();
      }
      // } else {
      //   this.resetCombobxs();
      // }
    },

    resetCombobxs() {
      this.dummyCnameModel = "";
      this.dummyPhoneModel = "";
      this.dummyAddressModel = "";
      this.customCnOnChangeHandler();
      this.customCpOnChangeHandler();
      this.customCaOnChangeHandler();
    },
    setSItemQuanNTotal(val) {
      if (val > 0) {
        // alert("hi")
        this.selected_sale_item.squantity = val;
        let res =
          parseFloat(this.selected_sale_item.unit_price) *
          parseFloat(this.selected_sale_item.squantity);

        this.selected_sale_item.total = res > 0 ? res : 0.0;
      } else {
        this.selected_sale_item.total = "";
      }
    },
  },
  mounted() {
    this.$store.dispatch("Customers/getAll");
  },
  computed: {
    ...mapGetters({
      current_user: "Auth/CURRENT_USER",
      stock_items: "Items/ITEMS",
      errors: "Items/ITEM_ERROR",
      salesloading: "Sales/SALES_LOADING",
      transactions: "Sales/SALES",
      recent_tran: "Sales/RECENT_SALE",
      terrors: "Sales/SALE_ERROR",

      customers: "Customers/CUSTOMERS",
      cerrors: "Customers/CUSTOMER_ERROR",
      cloading: "Customers/CUSTOMER_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",

      sms_balance: "sms/SMS_BALANCE",
      smserrors: "sms/SMS_ERROR",
      smsloading: "sms/SMS_LOADING",
    }),
    selectOptions() {
      if (this.stock_items) {
        let availableStock = this.stock_items
          .filter((x) => x.quantity > 0)
          .map((s) => ({
            label: s.name,
            value: s,
          }));
        return availableStock;
      } else {
        return null;
      }
    },
    customer() {
      return this.cust_name + "(" + this.cust_phone + ")";
    },
    amtTConfirmationRule() {
      let tst =
        this.trans_model.amt_tendered == 0 ||
        this.trans_model.amt_tendered >= this.trans_model.payable_amount; //if amount tendered is less than payabe amount trigger this
      return [
        //(this.password === this.rePassword) || 'Password must match',
        this.trans_model.amt_tendered >= 0 ||
          "Amount Tendered cannot be less than 0",
        tst || "Amount Tendered cannot be less than payable amount.",
        this.trans_model.amt_tendered !== "" || "Amount Tendered is required",
      ];
    },
    custNameRule() {
      let tst =
        this.trans_model.amt_tendered != 0 ||
        this.trans_model.mop != "Credit" ||
        this.trans_model.cust_name != "";
      return [tst || "Customer's name is required"];
    },

    // custAddressRule() {
    //   let tst =
    //     this.trans_model.amt_tendered != 0 ||
    //     this.trans_model.mop != "Credit" ||
    //     this.trans_model.cust_name != "";
    //   return [tst || "Customer's address/location is required"];
    // },

    custPhoneRule() {
      let tst =
        this.trans_model.amt_tendered != 0 ||
        this.trans_model.mop != "Credit" ||
        this.trans_model.cust_name == "" ||
        this.trans_model.cust_phone != "";

      let tst2 =
        this.trans_model.cust_phone == null ||
        this.trans_model.cust_phone == "" ||
        (this.trans_model.cust_phone &&
          this.trans_model.cust_phone.length <= 13);

      return [
        tst || "Customer's phone number is required",
        tst2 || "Phone number must not be more than 13 digits",
      ];
    },
  },
  watch: {
    dialog(val) {
      //console.log(val)
      if (val == false) {
        this.$store.dispatch("Sales/clearRecent");
      }
    },
    selected_sale_item(val) {
      val.unit_price ? this.$refs.purchQuan.focus() : "";
    },
    sitm_quan(val) {
      //this is to solve the vuex mutation problem

      this.setSItemQuanNTotal(val);
    },
    recent_tran(val) {
      //console.log(val)
      if (val && val.id) {
        this.transrcpt_model = val;
        this.dialog = true;
      }
    },
    "trans_model.vat_perc": function (val) {
      //re-calculating grand total
      let vat_percAmt =
        (parseFloat(val) / 100) * parseFloat(this.trans_model.cum_amt);
      let discAmt =
        (this.trans_model.discount_perc / 100) *
        parseFloat(this.trans_model.cum_amt);
      this.trans_model.payable_amount =
        this.trans_model.cum_amt + vat_percAmt - discAmt;
    },
    "trans_model.discount_perc": function (val) {
      //re-calculating grand total
      let vat_percAmt =
        (parseFloat(this.trans_model.vat_perc) / 100) *
        parseFloat(this.trans_model.cum_amt);
      let discAmt =
        (parseFloat(val) / 100) * parseFloat(this.trans_model.cum_amt);
      this.trans_model.payable_amount =
        this.trans_model.cum_amt + vat_percAmt - discAmt;
    },
    "trans_model.amt_tendered": function (val) {
      // if (val == 0) {
      //   this.trans_model.mop = "Credit";
      // } else {
      //   this.trans_model.mop = "Cash";
      // }
      let change =
        parseFloat(val) - parseFloat(this.trans_model.payable_amount); //change to grandtotal from cum_amt
      if (parseFloat(change) > 0) {
        this.trans_model.change_due = change;
      } else {
        this.trans_model.change_due = 0;
      }
    },
    "trans_model.cum_amt": function (val) {
      //re-calculating grand total
      let vat_percAmt = (parseFloat(this.trans_model.vat_perc) / 100) * val;
      let discAmt = (parseFloat(this.trans_model.discount_perc) / 100) * val;
      this.trans_model.payable_amount = val + vat_percAmt - discAmt;
    },
    "trans_model.mop": function (val) {
      if (val == "Credit") {
        this.trans_model.amt_tendered = 0;
        this.trans_model.change_due = 0;
      }
    },
    "trans_model.payable_amount": function (val) {
      // if (this.trans_model.amt_tendered == 0) {
      //   this.trans_model.mop = "Credit";
      // } else {
      //   this.trans_model.mop = "Cash";
      // }

      //re-calculating change due
      let change = parseFloat(this.trans_model.amt_tendered) - parseFloat(val);
      if (parseFloat(change) > 0) {
        this.trans_model.change_due = change;
      } else {
        this.trans_model.change_due = 0;
      }
    },
    // "trans_model.cust_phone": function(val) {
    //   console.log(val.length);
    // }
  },
};
</script>


